import { useContext, useEffect, useState } from "react"
import ApiContext from "src/provider/API/call-service"
import { AbsoluteContainer, AppSpan, AppText, CustomContainer, FlexRow, GridContainer, Icon, Input, ScreenTitle } from "src/style"
import { SmLogoCreation, SidePopupLayout } from "src/component"
import { FiSearch } from "react-icons/fi"
// import { banks, suggestedBanks } from "src/utils/mock-data"
import { banksImgSm, banksImgMd } from "src/utils/logo"
import { BsThreeDotsVertical } from "react-icons/bs"
import { IBank } from "src/model"
import helpers from "src/utils/helpers"

export const Banks: React.FC<any> = ({formData, handleSelect, bankData, next, close}) => {
    const {API} = useContext(ApiContext)
    const [banks, setBanks] = useState<IBank[] | any[]>([])
    const [mockBanks, setMockBanks] = useState<IBank[] | any[]>([])
    const[suggestedBanks, setSuggestedBanks] = useState<IBank[] | any[]>([])
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        if (bankData) {
            setBanks(bankData.otherBanks)
            setMockBanks(bankData.otherBanks)
            setSuggestedBanks(bankData.suggestedBanks)
        }
    }, [])

    function handleSearch (e: React.ChangeEvent<HTMLInputElement>) {
        setMockBanks(helpers.searchTableData(banks, e.target.value, ['bankAlias', 'bankName']))
    }

    async function handleBank (bank: IBank) {
        if (formData) {
            setIsLoading(true)
            const response = await API.nameInquiryOtherBank({
                senderAccountNumber: formData.senderAccount,
                beneficiaryAccountNumber: formData.beneficiaryAccount,
                beneficiaryBankCode: bank.bankCode
            })
            setIsLoading(false)
    
            if (response) {
                handleSelect({
                    ...formData, 
                    beneficiaryBank: bank.bankAlias, 
                    beneficiaryBankCode: bank.bankCode,
                    beneficiaryName: response.accountName,
                    canSaveBeneficiary: true,
                    nipSession: response.nipSession
                })
            }
            else handleSelect({...formData, beneficiaryAccount: ''})
        }

        next()
    }

    return (
        <SidePopupLayout close={close}>
            { (isLoading) &&
                <AbsoluteContainer top='0' left='0' zIndex='3' width='100' sizeUnit='%' height="full">
                    <GridContainer height='100' hUnit="%" bgColor='rgba(255, 255, 255, 0.5)'>
                        <AppSpan textSize='4' color='#0D968F' className='fa fa-spinner fa-spin' />
                    </GridContainer>
                </AbsoluteContainer>
            }
            <ScreenTitle textSize="2.2" fontWeight="700" topMargin="3">Select Bank</ScreenTitle>
            <CustomContainer
                radius='0.8' borderColor='#D0D5DD' 
                leftPadding='1.5' rightPadding='1.5' topMargin='2.5'
                shadow='0px 1px 2px rgba(16, 24, 40, 0.05)'
                bottomMargin='2'
            >
                <FlexRow>
                    <FiSearch style={{fontSize: '2rem', color: '#667085'}} />
                    <Input 
                        height='4.4' leftPadding='1' 
                        placeholder='Search' 
                        onChange={handleSearch}
                    />
                </FlexRow>
            </CustomContainer>
            <CustomContainer
                height='78' hUnit='%'
                className='overflow-y-container'
            >
                <CustomContainer>
                    <AppSpan>Suggested Bank</AppSpan>
                    <CustomContainer topMargin="1.5" className='scrollable-container'>
                        <FlexRow gap="1.5" style={{minWidth: 'fit-content'}}>
                            {
                                suggestedBanks?.map((bank, index) => {
                                    const img = bank.logoURL ? 
                                        <GridContainer width="4.5" height="4.5" style={{overflow: 'hidden'}}>
                                            <Icon src={bank.logoURL} noResize minWidth='100' style={{objectFit: 'contain'}} />
                                        </GridContainer> 
                                        : <LogoCreation name={bank.bankAlias} />
                                    return (
                                        <GridContainer 
                                            width="9" height="9" borderColor="#EAECF0"
                                            radius="0.8" key={index}
                                            className='suggested-bank'
                                            onClick={() => handleBank(bank)}
                                        >
                                            {img}
                                        </GridContainer>
                                    )
                                })
                            }
                        </FlexRow>
                    </CustomContainer>
                </CustomContainer>
                <CustomContainer topMargin='2'>
                    {
                        mockBanks?.map((bank: any, index: number) => {
                            const img = bank.logoURL ? 
                                <GridContainer width="3.5" height="3.5" radius="0.4" style={{overflow: 'hidden'}}>
                                    <Icon src={bank.logoURL} noResize minWidth='100' style={{objectFit: 'contain'}} />
                                </GridContainer> 
                                : <SmLogoCreation name={bank.bankAlias} />
                            return (
                                <GridContainer 
                                    minHeight="7.2" key={index}
                                    className="beneficiary-container"
                                    onClick={() => handleBank(bank)}
                                >
                                    <FlexRow justifyContent="space-between" gap="1.5" rightPadding="1.5">
                                        <FlexRow width="auto" sizeUnit='' gap="1.5">
                                            {img}
                                            <AppText fontWeight="600" color="#101828" cursor="pointer">{bank.bankName}</AppText>
                                        </FlexRow>
                                        <AppSpan textSize="1.6" color='#98A2B3'>
                                            <BsThreeDotsVertical/>
                                        </AppSpan>
                                    </FlexRow>
                                </GridContainer>
                            )
                        })
                    }
                </CustomContainer>
            </CustomContainer>
        </SidePopupLayout>
    )
}


export const LogoCreation: React.FC<any> = ({name, textSize}) => {
    return (
        <GridContainer height="100" hUnit="%" radius="0.4">
            <AppText 
                textSize={textSize || "2.5"} color="#667085" fontWeight="700" 
                fontFamily="Gilmer-Bold" cursor="pointer"
            >
                {name?.substring(0, 2).toUpperCase()}
            </AppText>
        </GridContainer>
    )
}